import {mapToTypeFromString} from '../../../common/common';
export enum EarningType {
  POINTS = 'POINTS',
  MILES = 'MILES'
}
export namespace EarningType {
  export const fromString = (input: string): EarningType => {
    return mapToTypeFromString<EarningType>(EarningType, input);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/user/earning-type.model.ts